import React from 'react';

export default React.createContext<[Filters, (filter: DataFilter[]) => void]>([
  [],
  () => null,
]);
